import React, { useEffect } from 'react';
import { ContactNavigation } from './contact/ContactNavigation';
import { ContactHeader } from './contact/ContactHeader';
import { ContactInfo } from './contact/ContactInfo';
import { ContactForm } from './contact/ContactForm';
import { ContactFooter } from './contact/ContactFooter';
export function ContactPage() {
  useEffect(() => {
    document.title = "Contact | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-727">
      <ContactNavigation data-id="element-728" />
      <ContactHeader data-id="element-729" />
      <section className="py-12 bg-[#111]" data-id="element-730">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-731">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-732">
            <ContactInfo data-id="element-733" />
            <ContactForm data-id="element-734" />
          </div>
        </div>
      </section>
      <ContactFooter data-id="element-735" />
    </div>;
}